// eslint-disable-next-line camelcase
import { required, email, url, min, min_value, max_value, is, length, confirmed } from '@vee-validate/rules'
import { configure, defineRule, type FieldValidationMetaInfo } from 'vee-validate'
import { localize, setLocale } from '@vee-validate/i18n'
import { useObuGlobalStore } from '@/pinia/ObuGlobalStore'
import { DateTime } from 'luxon'
import de from '@vee-validate/i18n/dist/locale/de.json'
import useSafePassword from '@/composables/useSafePassword'
import { storeToRefs } from 'pinia'

configure({
  generateMessage: localize({
    de
  })
})

setLocale('de')

export const Validations = () => {
  defineRule('required', required)
  defineRule('email', email)
  defineRule('min', min)
  defineRule('url', url)
  defineRule('min', min)
  defineRule('length', length)
  defineRule('min_value', min_value)
  defineRule('max_value', max_value)
  defineRule('is', is)
  defineRule('confirmed', confirmed)

  defineRule('vat_id', async (value: string, params: string, ctx: FieldValidationMetaInfo): Promise<string | boolean> => {
    let regexp
    const [isoCode, country, target] = params[0].split(':')
    console.log(target, ctx.form[target])
    if (ctx.form[target] === value) return true

    console.log(value, isoCode, country)
    switch (isoCode) {
      case 'DE':
        regexp = /^((DE)?[0-9]{9})$/
        break
      case 'IT':
        regexp = /^(IT)?[0-9]{11}$/
        break
    }
    if (regexp) {
      const result = regexp.test(value)
      console.log(result)
      if (result !== true) {
        return `Ist keine gültige Umsatzsteuer-ID für ${country}`
      }

      const globalStore = useObuGlobalStore()
      try {
        const result = await globalStore.checkVies(value)
        if (result.status === true) {
          return true
        }
        return `Ist keine gültige Umsatzsteuer-ID für ${country}`
        console.log(result)
      } catch (error) {
        return error as string
      }
    }

    return `Umsatzsteuer-IDs für ${country} werden nicht unterstützt.`
  })

  defineRule('min_items', (value: object[], params: string): string | boolean => {
    const parts = params[0].split(':')
    const minLength: number = parseInt(parts[0]) || 1
    const name: string = parts[1]
    const message: string = parts[2]
    const field: string = parts[3]

    let array
    if (name) {
      array = value.map(item => item[name]).filter(item => !!item)
    } else {
      array = value.map(item => item)
    }

    if (array.length < minLength) {
      if (field && message) {
        return `${field} muss mindestens ${minLength} ${message} enthalten`
      }
      return message
    }
    return true
  })

  defineRule('safe-password', async (value: string, params: string): Promise<string | boolean> => {
    const safePassword = useSafePassword()
    const { score } = storeToRefs(safePassword)
    safePassword.updatePassword(value)

    const [s] = params[0].split(':')
    console.log(score.value, s)

    if (parseInt(s) === parseInt(score.value)) return true

    return 'Das neue Kennwort ist nicht sicher genug.'
  })

  defineRule('is_date', (value: string | DateTime) => {
    const date: DateTime | null | string | undefined = !DateTime.isDateTime(value) ? DateTime.fromFormat(value, 'dd.MM.yyyy') : value
    if (DateTime.isDateTime(date)) {
      return true
    }

    return 'ist kein gültiges Datum'
  }

  )

  defineRule('domain', (value: string, params: string, ctx: FieldValidationMetaInfo) => {
    const regex = /^https?:\/\/(?=.{1,254}(?::|$))(?:(?!\d|-)(?![a-z0-9\-]{1,62}-(?:\.|:|$))[a-z0-9\-]{1,63}\b(?!\.$)\.?)+(:\d+)?$/mg
    const itemNumberRegEx = /\[\d\]/gm
    if (!regex.test(value)) {
      const result = itemNumberRegEx.exec(ctx.name)
      if (result !== null) {
        const stringIndex: string = result[0].replace('[', ':').replace(']', '').substring(1)
        const fieldIndex: number = parseInt(stringIndex) + 1

        return `${fieldIndex}. ${params[0]} ist keine gültige Domain.`
      }
      return true
    }

    return true
  })
}
